export const ValidationMessages = {
  required: 'Required field',
  maxLength: (length: number) => `Max length is ${length} characters`,
  minLength: (length: number) => `${length} characters required`,
};
